import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

import { LearningSuccessControl } from '../models/learningSuccessControl.model';
import { Activity } from '../models/activity.model';
@Injectable({
  providedIn: 'root',
})
export class LearningSuccessControlService {
  private apiUrl = environment.apiUrl + '/LearningSuccessControl';

  http = inject(HttpClient);

  saveLearning(
    learningSuccessControl: LearningSuccessControl
  ): Observable<Activity> {
    return this.http.post<Activity>(
      `${this.apiUrl}/CreateLearningSuccessControl`,
      learningSuccessControl
    );
  }
}
